import * as R from 'ramda';

import type { EngineConfig, PluginConfigEntry } from '@typings/plugin-runtime.ts';
import { b64DecodeUnicode } from '@utils/funcs.ts';

type DecodedState = Record<string, Record<string, unknown>>;

export function process(config: EngineConfig) {
  const parms = new URLSearchParams(location.search);
  const stateString64 = parms.get('s');
  if (stateString64) {
    return setStateFromStateString(config, b64DecodeUnicode(stateString64));
  }

  return config;
}

/**
 * Given a state string (JSON representation of latest state) this will update the
 * app config by applying plugin deep-link state.
 *
 * Note: forceCreate is a potential security risk. It is used by the SDK before
 * extends is processed, so it is still needed there.
 */
export function setStateFromStateString(config: EngineConfig, stateString: string, forceCreate = false) {
  const state = JSON.parse(stateString) as DecodedState;

  // Iterate through each state object, which has a plugin id and key/value state props.
  Object.keys(state).forEach(id => {
    const stateObject = state[id];
    let pluginConfig = config.plugins[id];
    if (!pluginConfig && forceCreate) {
      pluginConfig = config.plugins[id] = {};
    }
    if (!pluginConfig) {
      return;
    }

    const currentDeepLinkProps = pluginConfig.deepLinkProps;
    if (!currentDeepLinkProps) {
      pluginConfig.deepLinkProps = stateObject as PluginConfigEntry['deepLinkProps'];
      return;
    }

    pluginConfig.deepLinkProps = R.mergeDeepRight(
      currentDeepLinkProps,
      stateObject,
    ) as PluginConfigEntry['deepLinkProps'];
  });

  return config;
}
